import { primeAccountSetupFromBootstrap } from '../../shell/session/accountSetupService';
import { getOfflineAccountSnapshot, snapshotImpliesOfflineOperational } from './offlineAccountCache';

/**
 * ADR-017 Fase 4: SQLite eliminado como path de datos operacional.
 * `db` es un stub que retorna `undefined`/no-op en todas las plataformas.
 * La evidencia operacional local (ventas, productos, categorías, branches_cache)
 * siempre está vacía; el snapshot offline es la única fuente, y también está vacía.
 */

/** True si puede usarse la app sin pantalla "Necesitás internet" (bootstrap de cuenta). */
export async function computeOfflineBootstrapEvidence(userId: string): Promise<boolean> {
  const snap = await getOfflineAccountSnapshot(userId);
  return snapshotImpliesOfflineOperational(snap);
}

/**
 * Cuando hay evidencia local/snapshot pero el bootstrap remoto dejó `requiresOwnerOnboarding` en null,
 * primar el gate operativo para habilitar POS y sync en background offline.
 */
export async function primeOperationalGateFromOfflineEvidence(userId: string): Promise<boolean> {
  const evidence = await computeOfflineBootstrapEvidence(userId);
  if (!evidence) return false;

  const snap = await getOfflineAccountSnapshot(userId);
  primeAccountSetupFromBootstrap(userId, {
    requiresOwnerOnboarding: false,
    ownerSetupCompletedAt: snap?.ownerSetupCompletedAt ?? null,
    organizationId: snap?.accountSetupOrganizationId ?? snap?.entitlements?.organization_id ?? null,
    branchCount: snap?.accountSetupBranchCount ?? snap?.branches?.length ?? 0,
    organizationClosedAt: snap?.accountSetupOrganizationClosedAt ?? null,
    awaitingEmployeeInvitation: snap?.awaitingEmployeeInvitation === true,
  });
  return true;
}
